<template>
  <a-layout>
    <a-layout-content class="project-offer-list"
      :style="{ margin: '24px 16px', padding: '24px', background: '#fff'}">
      <!-- <div class="performance-list-header">数据表</div> -->
      <div class="dependDataSearch">
        <!-- <a-input placeholder="请输入工号、姓名" style="width:168px;" v-model="key_word" /> -->
         <a-month-picker placeholder="选择补报月份" :format="'YYYY-MM'" v-model="query.additionMonth"
          :disabledDate="disabledDate" @change="handleMonthChange" :allowClear='false'>
          <a-icon slot="suffixIcon" :component="'SvgIcDate'" />
        </a-month-picker>
        <a-select v-model="query.employeeUid" placeholder="请输入工号、姓名" showSearch style="width:168px;"
          :filter-option="false" :not-found-content="null" allowClear :show-arrow="false" @search="searchEmployee">
          <a-spin v-if="loading" slot="notFoundContent" size="small" />
          <a-select-option v-for="e in employeeAdditionOptions" :key="e.employeeUid"
            :value="e.employeeUid">
            {{ e.optionName}}
          </a-select-option>
        </a-select>
        <a-select showSearch placeholder="部门" v-model="query.deptId" style="width:168px;"
          :filter-option="false" :not-found-content="null" allowClear :show-arrow="false" @search="searchDep">
          <a-spin v-if="loading" slot="notFoundContent" size="small" />
          <a-select-option v-for="dep in departmentEntityListOpts" :key="dep.id" :value="dep.dept_id">
            {{dep.dept_name}}
          </a-select-option>
        </a-select>




        <!-- <a-input placeholder="部门" style="width:168px;" v-model="key_word" /> -->
      
        <a-button type="primary" @click="search">查询</a-button>
        <a-button @click="clear">清空</a-button>
      </div>
      <div class="btns">
        <a-button @click="additionAdd(true)" :disabled="moment().get('date') > 15 || moment().get('date') < 3" type="primary">工时补报</a-button>
      </div>
      <a-table class="dependDataTable" :rowKey="record => record.id" :columns="columns"
        :dataSource="dataSource" :pagination="pagination" :loading="loading" @change='changePage'>
        <span slot="additionDates" slot-scope="text, record">

          <a-tooltip v-if="text.length>10">
            <template #title>

              {{text}}
            </template>
            <span>{{text.slice(0,10)+'...'}}</span>
          </a-tooltip>
          <span v-else>{{text}}</span>
        </span>
        <span slot="action" slot-scope="text, record">
  <a-popconfirm title="是否确认删除"  ok-text="确认" @confirm="deleteRecord( record.id)" cancel-text="取消">

          <a href="#">删除</a>
  </a-popconfirm>
        </span>
      </a-table>
      <a-modal v-model="reFillModal" title="工时补报" :width='800' destroyOnClose>
      
        <div class='reFillModalContainer'>
          <div class='other'>
            是否需要其他人代报工时：<span>
              <a-radio-group v-model="needOther" :disabled='!!checked.length' @change="additionAdd">
                <a-radio :value="1">
                  是
                </a-radio>
                <a-radio :value="2">
                  否
                </a-radio>
              </a-radio-group>
            </span>
          </div>
          <div class='searchTree'>
            <div class='searchTree_left'>
              <a-input-search style="margin-bottom: 8px" placeholder="Search"
                @change="searchChange" />
              <a-tree :expanded-keys="expandedKeys" checkable :tree-data="treeData"
                @expand="onExpand" @check="onCheck" ref="aTree" :checkedKeys="checkedKeys">
                <template slot="title" slot-scope="{ title }">
                  <span v-if="title.indexOf(searchValue) > -1">
                    {{ title.substr(0, title.indexOf(searchValue)) }}
                    <span style="color: #f50">{{ searchValue }}</span>
                    {{ title.substr(title.indexOf(searchValue) + searchValue.length) }}
                  </span>
                  <span v-else>{{ title }}</span>
                </template>
              </a-tree>
            </div>
            <div class='searchTree_right'>
              <span class="count">当前已选{{checked.length}}人</span>

              <!-- <div></div> -->
              <a-table :columns="selectedCol" :data-source="checked" size="small"
                :pagination='false' bordered>
                <span slot="action" slot-scope="text, record">
                  <a-select v-if="needOther===1" allowClear style="width:168px;" showSearch
                    v-model="checked[record.i].agentUid" :filter-option="false"
                    :not-found-content="null" @search="searchAgent($event,record)">
                    <!-- <a-spin v-if="loading" slot="notFoundContent" size="small" /> -->
                    <a-select-option v-for="(agent,) in agentOpts[record.i]"
                      :key="agent.agentUid" :value="agent.agentUid">
                      {{ agent.optionName}}
                    </a-select-option>
                  </a-select>
                </span>
              </a-table>
            </div>
          </div>

          <div>

          </div>
        </div>



  <template slot="footer">
          <a-button key="back" @click="handleCancel">
            取消
          </a-button>
          <a-button key="submit" type="primary" :loading="submitLoading" @click="handleOk">
            提交
          </a-button>
        </template>
      </a-modal>
    </a-layout-content>
  </a-layout>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
import SvgIcDate from '../../assets/svg/ic-date-o.svg';
import {
  getAdditionRecordList,
  getAdditionRecordOptions,
  getAdditionRecordEmployeeTree,
  deleteAdditionRecord,
  addAdditionRecord,
  getAdditionAgentList
} from '../../services/DataManageService.js';
import {
  downloadFile,
  getParentKeyByTree,
  getLastChildInTree,
  handleTreeSearch,
  throttle
} from '../../utils/tools';
import {

  cloneDeep,

} from 'lodash';
// import moment from 'moment';
export default {
  name: 'disposeHouersRefill',
  components: {
    SvgIcDate,
  },
  data() {
    return {
      query: {
        // employeeUid:undefined,
        additionMonth: moment().subtract(1, 'month'),
        // deptId:'',
      },
      treeKey: 0,
      needOther: 2,
      // checkedKeys: [],
      checked: [
        //   {
        //   title: "0-0-0-0",
        //   key: "0-0-0-0"
        // }
      ],
      checkedKeys: [],
      select_changeKey: null,
      selectedCol: [{
          title: '姓名',
          dataIndex: 'title',
          width: '150px'
        },
        {
          title: '代报人',
          scopedSlots: {
            customRender: 'action'
          },
          // width: 200,
          key: 'action',
        },
      ],
      breadcrumb: [{
          label: '数据管理',
          path: '',
        },
        {
          label: '工时补报',
          path: '',
        },
      ],
      searchValue: '',
      total: 0,
      loading: false,
      submitLoading: false,
      reFillModal: false,

      key_word: '',
      dataSource: [],
      columns: [{
          title: '工号',
          dataIndex: 'jobId',
          key: 'jobId',
        },
        {
          title: '姓名',
          dataIndex: 'employeeName',
          key: 'employeeName',
        },
        {
          title: '部门',
          dataIndex: 'deptName',
          key: 'deptName',
        },
        {
          title: '补报月份',
          dataIndex: 'additionMonth',
          key: 'additionMonth',
        },
        {
          title: '补报日期',
          dataIndex: 'additionDates',
          key: 'additionDates',
          scopedSlots: {
            customRender: 'additionDates'
          },

        },
        {
          title: '操作人',
          dataIndex: 'operatorName',
          key: 'operatorName',
          width: 100,
        },
        {
          title: '操作时间',
          dataIndex: 'operateTime',
          key: 'operateTime',
        },
            {
          title: "代报人",
          dataIndex: "reportAgentName",
          key: "reportAgentName",
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: {
            customRender: 'action'
          },
        },
      ],
      pagination: {
        total: 0,
        defaultCurrent: 1,
        defaultPageSize: 10,
        current: 1,
        pageSize: 10,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "30", "40", "50"]
      },
      employeeAdditionOptionVoList: [],
      employeeAdditionOptions: [],
      departmentEntityList: [],
      departmentEntityListOpts: [],
      agentOpts: [],

      expandedKeys: [],
      treeData: [],
      sourceTreeData: [],
      timer: null
    };
  },
  created() {

    this.fetchData();
    this.getOpts();

  },
  computed: {
    lastLevelTreeData() {
      return getLastChildInTree(this.treeData)
    },
    disableAdd() {
      const nowDate = moment(new Date()).get('date');
      return nowDate > 15 && nowDate < 3
    },
    checkedRealKeys() {
      let arr = [];
      if (this.checked.length > 0) {
        this.checked.forEach(item => arr.push(item.key));
      }
      return arr;
    },
  },
  methods: {
    moment,
    handleMonthChange(){
      this.getOpts()
      delete this.query.employeeUid
      delete this.query.deptId
      // this.query.employeeUid=null
      // this.query.deptId=null
    },
    searchEmployee(val) {
      if (val) {

        this.employeeAdditionOptions = this.employeeAdditionOptionVoList.filter(employee => {
          const res = employee.optionName.replace('[工号：', '').replace('][在职]', '').replace(
            '][离职]', '')
          //待后端定义后删除不必要搜索
          return res.includes(val)
        })
      } else {
        this.employeeAdditionOptions = []
      }



    },
    searchDep(val) {
      if (val) {
        this.departmentEntityListOpts = this.departmentEntityList.filter(dep => {

          return dep.dept_name.includes(val)
        })
      } else {
        this.departmentEntityListOpts = []
      }



    },

    getOpts() {
      getAdditionRecordOptions({additionMonth: this.query.additionMonth.format("YYYYMM")}).then(res => {
        if (res.status === 'success') {
          this.departmentEntityList = res.data.departmentEntityList
          this.employeeAdditionOptionVoList = res.data.employeeAdditionOptionVoList
        }
      })
    },
    additionAdd(newModal) {
      if (newModal === true) {
        this.needOther = 2;
      }
      this.checked = [];
      getAdditionRecordEmployeeTree().then(res => {
        if (res.status === 'success') {
          const {
            deptTree
          } = res.data
          this.treeData = [];
          this.sourceTreeData = [];
          this.checkedKeys = [];
          this.searchValue = '';
          const formatNode = (node, lev = '0') => { //视情况可以提出
            // console.log(node);
            const res = {
              title: node.deptName || node.employeeName || '全部',
              key: lev,
              id: (node.deptId) || (node.employeeUid) || 0,
              scopedSlots: {
                title: 'title'
              },
              employeeUid: node.employeeUid,
              agentUid:  node.defaultAgentUid, //默认代报人
              optionName: node.defaultAgentName,
              disableCheckbox: node.isDel && this.needOther === 2 //: node.defaultAgentName,

            }
            if (node.employeeList && node.employeeList.length) { //树状结构整理
              node.children = node.employeeList.concat(node.children)
            }
            if (node.children && node.children.length) {
              res.children = node.children.map((child, i) => {
                // console.log(child);
                return formatNode(child, lev + '-' + i)
              })
            }
            // console.log(res);
            return res
          }
          // this.checked=[]
          this.treeData = [formatNode({
            children: deptTree
          })]
          this.expandedKeys = ['0'];
          this.sourceTreeData = _.cloneDeep(this.treeData);
          this.reFillModal = true
        } else {
          this.$Message.error(res.message)
        }

      })
    },
    disabledDate(current) {
      return current && current > moment().subtract(1, 'month').endOf('day');
    },
    fetchData(query) {
      const params = _.cloneDeep(this.query)
      if (params.additionMonth) {

        params.additionMonth = params.additionMonth.format("YYYYMM")
      } else {
        this.$Message.error('请选择查询月份')
        return
      }
      this.loading = true;
      getAdditionRecordList(params).then(res => {
        this.loading = false;
        if (res.status === 'success') {
          const {
            data
          } = res
          this.dataSource = data.list
          this.pagination.total = data.total;

        } else {
          this.$Message.error(res.message)
        }
      });
    },
    search() {
      this.query.page = 1;
      this.pagination.current = 1;
      this.fetchData(
        this.query
      );
    },
    clear() {
      this.query = {
        additionMonth: moment().subtract(1, 'month'),
      }
      this.fetchData();
          this.getOpts();
    },

    deleteRecord(id) {
      deleteAdditionRecord({
        id
      }).then(res => {
        if (res.status === 'success') {
          this.$Message.success('删除成功');
          this.search();
        } else {
          this.$Message.error(res.message);
        }
      })
    },

    // search:()=>{

    //   return _.throttle((row)=>{
    //   console.log(this);
    //  this.agentOpts[row.i] = []
    //       getAdditionAgentList({
    //         query: e
    //       }).then(res => {
    //         if (res.status === 'success') {
    //         this.$set(this.agentOpts,row.i, res.data.map(item => {
    //             item.agentUid = item.employeeUid
    //             item.optionName = item.optionName
    //             return item
    //           }).slice(0, 100))
    //         } else {
    //           this.$Message.error(res.message);
    //         }
    //       })
    // }, 1000)}

    searchAgent(e, row) {

      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null
      }




      this.timer = setTimeout(() => {

        this.timer = null


        this.agentOpts[row.i] = []
        getAdditionAgentList({
          query: e
        }).then(res => {
          this.loading = false;
          if (res.status === 'success') {
            this.$set(this.agentOpts, row.i, res.data.map(item => {
              item.agentUid = item.employeeUid
              item.optionName = item.optionName
              return item
            }).slice(0, 100))
          } else {
            this.$Message.error(res.message);
          }
        })
      }, 500)



    },
    handleCancel() {
      this.reFillModal = false
    },
    handleOk() {
      if (!this.checked.length) {
        this.$Message.error("请选择人员");
        return
      }
      if (this.checked.length > 600) {
        this.$Message.error('最大添加人数限制600人');
        return
      }
      let reportAgentUidTester=true
      const addList = this.checked.map(item => {
        const res = {
          employeeUid: item.employeeUid,
        }
        if (this.needOther===1) {
          if (!item.agentUid) {
            reportAgentUidTester=false
          } else {
            res.reportAgentUid = item.agentUid
          }
        }
        return res
      })
       
      if (!reportAgentUidTester) {
           this.$Message.error("请选择代报人");
        return
      }
      // debugger
      this.submitLoading = true;
      addAdditionRecord({
        addList
      }).then(res => {
        if (res.status === 'success') {
          this.reFillModal = false
          this.$Message.success('添加完成');
          this.query.page = 1
          this.pagination.current = 1;
          this.fetchData()
        } else {
          this.$Message.error(res.message);
        }
        this.submitLoading = false;
      })
    },
    searchChange(e) {
      this.searchValue = e.target.value;
      let sourceData = _.cloneDeep(this.sourceTreeData);
      // 获取符合条件的叶子节点
      let lastLevs = getLastChildInTree(sourceData)
        .filter(item => item.title.includes(this.searchValue))
        .map(item => getParentKeyByTree(item.key, sourceData))
      let lastLev = [...new Set(lastLevs)];
      // 获取目标路径
      const path = lastLev.map(item => {
        const pathArr = item.split('-')
        let res = pathArr.map((item, i) => {
          return pathArr.slice(0, i).join('-')
        })

        return res
      })
      let res = []
      path.forEach(item => {
        res = res.concat(item) //item
      })
      // 获取路径的key
      this.expandedKeys = [...new Set(res)].concat(lastLev)
      //处理treeData
      if (this.searchValue == '' || this.searchValue === undefined) {
        this.checkedKeys = this.checkedRealKeys; // 更新当前选中
        this.$set(this, 'treeData', sourceData);
        this.expandedKeys = ['0'];
      } else {
        let dataRes = handleTreeSearch(sourceData, this.expandedKeys, this.searchValue);
        this.$set(this, 'treeData', dataRes);
        let checked = getLastChildInTree(sourceData).filter(item => item.title.includes(this.searchValue) && this.checkedRealKeys.includes(item.key));
        this.checkedKeys = [];
        if (checked.length > 0) { // 更新当前选中
          checked.forEach(item => this.checkedKeys.push(item.key));
        }
      }


    },
    onCheck(checkedKeys, info) {//可待优化
      let checkedData = [];
      if ((this.searchValue + '').length > 0) {
        // checked = 当前树选择 + 其他
        const lastLevelTreeDataKeys = [];
        this.lastLevelTreeData.forEach(item => {
          lastLevelTreeDataKeys.push(item.key)
        })
        if (this.checked.length > 0) {
          this.checked.forEach(item => {
            if (!lastLevelTreeDataKeys.includes(item.key)) {
              checkedData.push(item);
            }
          })
        }
        checkedData = checkedData.concat(this.lastLevelTreeData.filter(item => {
          return checkedKeys.includes(item.key)
        }))
      } else {
        checkedData= this.lastLevelTreeData.filter(item => {
          return checkedKeys.includes(item.key)
        })
      }
      this.checkedKeys = checkedKeys;
      checkedData.map((item, i) => {
        if (!this.agentOpts[i]) {
          this.agentOpts[i] = []
        }
        return {
          agentUid: item.agentUid,
          optionName: item.optionName
        }
      }).forEach((item, i) => {
        const existList = this.agentOpts[i].map(opt => opt.agentUid)
        if (!existList.includes(item.agentUid)) {
          this.agentOpts[i].push(item)
        }
      })
      this.checked = checkedData.map((item, i) => {
        const checkedItem = this.checked.find(checkedItem => item.id === checkedItem.id)
        if (checkedItem) {
          item.agentUid = checkedItem.agentUid
        }
        // if (this.checked[i]) {
        //   item.agentUid = this.checked[i].agentUid
        // }
        return Object.assign({
          i
        }, item)
      })
    },
    changePage(page, size) {
      
      this.pagination = Object.assign(this.pagination, page)
      this.query.page = this.pagination.current
      this.query.pageSize = this.pagination.pageSize
      this.fetchData()
      this.getOpts()

    },
    onExpand(expandedKeys) {

      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },


  },
};
</script>

<style lang="less">
.dependDataSearch {
  margin-bottom: 16px;
  .ant-select,
  .ant-btn {
    height: 29px;
    line-height: 28px;
    margin-right: 16px;
  }
  .ant-calendar-picker {
    margin-right: 16px;
  }
}
.btns{
  margin-bottom: 16px;
}
.reFillModalContainer{
  .searchTree{
    display: flex;
    >*{
      flex-shrink: 1;

      width: 50%;
      border: 1px solid #d9d9d9;
      height: 400px;
      overflow:auto;
    }
    
    .searchTree_left{
      border-right: none;
      }
    .searchTree_right{
      
      // width: 50%;
      // border: 1px solid #d9d9d9;
      .count {
        line-height: 30px;
        margin-left: 10px;
        color: rgba(0, 0, 0, 0.25);
      }
      .ant-table-small {
        border-radius: 0;
      }
    }
  }
}
.dependDataTable {
  .operation {
    display: flex;
    color: rgba(0, 0, 0, 0.38);
    span {
      font-size: 12px;
      margin-right: 24px;
      cursor: pointer;
    }
    span:last-child {
      margin-right: 0px;
    }
    .blueFont {
      color: #0295ee;
    }
  }
  .exec_status_desc {
    display: flex;
    .circle {
      height: 8px;
      width: 8px;
      margin-top: 8px;
      margin-right: 5px;
      border-radius: 50%;
    }
    .circleColor1 {
      background: #8b9aad;
    }
    .circleColor2 {
      background: #0295ee;
    }
    .circleColor3 {
      background: #2dbe60;
    }
    .circleColor4 {
      background: #ed5a2b;
    }
  }
  .ant-upload-list {
    display: none;
  }
}
</style>
